import { render, staticRenderFns } from "./TableFactures.vue?vue&type=template&id=662e9ab2&"
import script from "./TableFactures.vue?vue&type=script&lang=js&"
export * from "./TableFactures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports